import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import Swiper from '../Swiper.js'
import ReactSwiper from 'templates/shared/components/ReactSwiper'
// import cx from 'classnames'

import LastScene from '../scenes/LastScene'
import ShowcaseLink from './ShowcaseLink'

import './CubeSwiper.scss'
import RedirectScene from '../scenes/RedirectScene'

// const params = {
//   effect: 'cube',
//   resistance: false,
//   speed: 800,
//   loop: false,
//   cube: {
//     shadow: false,
//     slideShadows: false,
//     shadowOffset: 0,
//     shadowScale: 0
//   }
// }

export default class CubeSwiper extends Component {

  constructor (props) {
    // console.log('CubeSwiper constructor showcases:', props.showcases, props.slide)
    super(props)
    this.uniqKey = Date.now()
  }

  shouldComponentUpdate (nextProps) {
    const showcasesCanged = nextProps.showcases.length !== this.props.showcases.length
    const lastSceneChanged = nextProps.lastScene !== this.props.lastScene
    const addRedirectSceneChanged = nextProps.addRedirectScene !== this.props.addRedirectScene
    const redirectUrlChanged = nextProps.redirectUrl !== this.props.redirectUrl
    const slideChanged = nextProps.slide !== this.props.slide
    const editModeChanged = nextProps.editMode !== this.props.editMode
//     console.log('showcasesCanged', showcasesCanged, 'lastSceneChanged', lastSceneChanged, 'addRedirectSceneChanged', addRedirectSceneChanged, 'redirectUrlChanged', redirectUrlChanged, 'slideChanged', slideChanged, 'editModeChanged', editModeChanged)
    return showcasesCanged || lastSceneChanged || addRedirectSceneChanged || redirectUrlChanged || slideChanged || editModeChanged
  }

  componentWillReceiveProps (nextProps) {
//    console.log('componentWillReceiveProps', nextProps.showcases, nextProps.slide)
    if (this.swiper) this.swiper.swiper.update()
  }

  handleSlideChange = (swiper) => {
    // const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    // if (isIos) {
    //   document.getElementsByClassName('swiper-container-3d')[0].style.perspective = 'none'
    // } else {
    //   document.getElementsByClassName('swiper-container-3d')[0].style.perspective = '1px'
    // }
    this.props.onSlideChange(swiper.activeIndex)
  }

  renderLastScene = () => {
    const { lastScene, editMode, addRedirectScene, setShareButtonsVisible, showcases } = this.props

    let lastSceneLayout = []
    if (lastScene) {
      const l = (
        <LastScene
          social={lastScene.social}
          shareTitle={lastScene.shareTitle}
          shareSubtitle={lastScene.shareSubtitle}
          image={lastScene.image}
          title={lastScene.title}
          author={lastScene.author}
          subtitle={lastScene.subtitle}
          key={showcases.length}
          editMode={editMode}
          setShareButtonsVisible={setShareButtonsVisible}
        />
      )
      lastSceneLayout.push(l)
    }

    if (addRedirectScene) {
      lastSceneLayout.push(this.renderRedirectScene())
    }
    return lastSceneLayout
  }

  renderShowcases = () => {
    const { showcases, showProduct } = this.props

    return showcases.map((showcase, idx) => {
      const slideId = showcase.slideId ? showcase.slideId : idx
      return (
        <div className={`slide ou_showcase_${idx} js-scroll-x`} key={idx} >
          <div className='ou_showcase__image-container'>
            <div
              id={`ou_showcase__image${idx}`}
              style={{backgroundImage: `url(${showcase.image})`}}
              className={`ou_showcase__image ou_showcase_${idx}_image ou_showcase_${slideId}_image_p js-scroll-x`}
            />
            <div
              id={`ou_showcase__image_preview${idx}`}
              className={`ou_showcase__image js-scroll-x`}
            />
          </div>
          {showcase.products && showcase.products[0] && showcase.products.map((product, idx) =>
            <ShowcaseLink
              key={product.id}
              productId={product.id}
              content={product.title}
              x={product.x}
              y={product.y}
              onLinkClick={() => showProduct(product.id)}
              idx={idx}
              slideId={showcase.slideId}
            />)
          }
        </div>
      )
    })
  }

  renderRedirectScene = () => {
    const { showcases, redirectUrl, slide } = this.props
    return (
      <RedirectScene
        key='redirectScene'
        redirectUrl={redirectUrl}
        isLoaded={slide === showcases.length + 1}
      />
    )
  }

  renderSwiperContent = () => {
    const { showcases } = this.props
    if (showcases) {
      const renderedShowcases = this.renderShowcases()
      const renderedLastScene = this.renderLastScene()
      const res = renderedShowcases.concat(renderedLastScene)
      return res
    }
  }

  onSwiperInit = () => {
    // console.log('onSwiperInit')
    // if (this.swiper) this.swiper.swiper.slideTo(0)
    // this.forceUpdate()
  }

  onSlideChange = () => {
    // console.log('onSlideChange', this.swiper)
    if (this.swiper) this.handleSlideChange(this.swiper.swiper)
  }

  onSwiperMounted = (ref) => {
    if (ref) this.swiper = ref
  }

  render () {
    const { slide } = this.props
    // console.log('slide', slide, 'isString', slide instanceof String)
    return (
      <ReactSwiper
        id='showcase_swiper'
        // key={this.uniqKey}
        effect='cube'
        ref={this.onSwiperMounted}
        resistance={false}
        speed={800}
        loop={false}
        containerClass='swiper-container ou_swiper'
        cubeEffect={{
          shadow: false,
          slideShadows: false,
          shadowOffset: 0,
          shadowScale: 0
        }}
        on={{
          slideChangeTransitionEnd: this.onSlideChange,
          init: this.onSwiperInit,
          // slideChange: this.onSlideChange
        }}
        activeSlideKey={slide.toString()}
        initialSlide={slide.toString()}
        autoHeight
        shouldSwiperUpdate
        a11y
      >
        {this.renderSwiperContent()}
      </ReactSwiper>

      // <Swiper
      //   {...params}
      //   id='swiper'
      //   classNames={['ou_swiper']}
      //   onTransitionEnd={this.handleSlideChange}
      //   slide={slide}
      // >
      //   {this.renderSwiperContent()}
      // </Swiper>
    )
  }

  static defaultProps = {
    onSlideChange: () => null
  }

  static propTypes = {
    showcases: PropTypes.array,
    lastScene: PropTypes.object,
    addRedirectScene: PropTypes.bool,
    redirectUrl: PropTypes.string,
    slide: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
    showProduct: PropTypes.func,
    onSlideChange: PropTypes.func,
    editMode: PropTypes.bool,
    setShareButtonsVisible: PropTypes.func
  }
}



// WEBPACK FOOTER //
// ./src/templates/outSide/components/showcase/CubeSwiper.js